import { chiRandom, groupCenter } from './stats.js'

export default function shotsToZero (sd, scopeAdjustment) {
  const results = []
  ;[ 1, 3, 5, 10, 15, 20, 25, 50, 100 ].forEach(shots => {
  //;[ 1 ].forEach(shots => {
    let count = 0
    let zeroedCount = 0
    let almostZeroedCount = 0
    let pointSamples = []
    for (let i = 0; i < 10000; i++) {
      const points = []
      for (let shot = 0; shot < shots; ++shot) {
        let angle = Math.random() * 2 * Math.PI
        let length = Math.abs(chiRandom(sd))
        let x = length * Math.cos(angle)
        let y = length * Math.sin(angle)
        points.push({ x, y })
      }
      const center = groupCenter(points)
      const almostZeroedX = Math.abs(center.x) < scopeAdjustment
      const almostZeroedY = Math.abs(center.y) < scopeAdjustment
      const almostZeroed = almostZeroedX && almostZeroedY
      const zeroedX = Math.abs(center.x) < (scopeAdjustment / 2)
      const zeroedY = Math.abs(center.y) < (scopeAdjustment / 2)
      const zeroed = zeroedX && zeroedY

      ++count
      if (zeroed) ++zeroedCount
      if (almostZeroed) ++almostZeroedCount
      if (i < 6) pointSamples.push({ points, zeroed, almostZeroed, center })
    }
    results.push({
      shots,
      pointSamples,
      percent: (100 * (zeroedCount / count)).toFixed(1) + '%',
      almostPercent: (100 * (almostZeroedCount / count)).toFixed(1) + '%'
    })
  })
  return results
}
